import React from "react";
import { Box, List, ListItemText, Typography } from "@mui/material";
import QRCode from "react-qr-code";
import { toLKR } from "../helpers/cal";

export default function JobTicket({ j, jobStkRecs, allPapers }) {
  const jobfileTag = (i) => String(i || 0).padStart(5, "0");
  const inf = j?.job_info;

  const bd = { border: "1px solid black" };
  const bdt = { borderTop: "1px solid black" };
  const mid = { alignContent: "center" };

  const blnk = {
    color: "darkblue",
    borderBottom: "1px solid #7a7a7a",
    textDecoration: "underline",
    textDecorationColor: "#7a7a7a",
    textDecorationThickness: "1px",
    textUnderlineOffset: "6px",
    display: "block",
    width: "100%",
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "anywhere",
    fontStyle: "italic",
    pt: 0.5,
  };
  const noblnk = {
    color: "darkblue",
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "anywhere",
    fontStyle: "italic",
  };

  const whatList = (type) => {
    switch (type) {
      case "Paper":
        return allPapers || [];
      default:
        return [];
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        minHeight: 0,
      }}
    >
      {/* Header */}
      <Box
        sx={{
          ...bd,
          mx: 3,
          mt: 3,
          display: "flex",
          height: "5%",
          flexShrink: 0,
          minHeight: 64,
        }}
      >
        <Box
          sx={{
            ...bd,
            flex: "0 0 30%",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography variant="h5" sx={{ mx: 1 }}>
            Units
          </Typography>
          <Typography variant="h6" sx={{ color: "darkblue" }}>
            {inf?.unit_count?.toLocaleString()}
          </Typography>
          <Typography
            variant="h6"
            sx={{ color: "darkblue", fontSize: 16, ml: 2, mr: 1, ...noblnk }}
          >
            {!!(inf?.items_qty && inf?.items_def) &&
              `${inf?.items_qty?.toLocaleString()} ${inf?.items_def}`}
          </Typography>
        </Box>

        <Box
          sx={{
            ...bd,
            flex: "0 0 40%",
            bgcolor: "black",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="h3" color="white" fontWeight="bold">
            JOB TICKET
          </Typography>
        </Box>

        <Box
          sx={{
            ...bd,
            flex: 1,
            display: "flex",
            alignItems: "center",
            pl: 5,
            minWidth: 0,
          }}
        >
          <Typography sx={{ ...noblnk, color: "darkblue", minWidth: 0 }}>
            #
            {!!j?.file_id &&
              jobfileTag(j?.file_id) + "_" + (j?.job_code || j?.job_index)}
          </Typography>

          <Box
            sx={{
              ml: "auto",
              height: "100%",
              aspectRatio: "1 / 1",
              border: "2px solid black",
              flexShrink: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: 0.5,
              bgcolor: "white",
            }}
          >
            {j?.jobfile_id && j?.job_index && (
              <QRCode
                value={`https://www.nimthara.com/jobs/job/${j?.file_id}/${j?.job_index}`}
                style={{ width: "100%", height: "100%" }}
              />
            )}
          </Box>
        </Box>
      </Box>

      {/* Middle  */}
      <Box
        sx={{
          ...bd,
          mx: 3,
          display: "flex",
          height: "70%",
          minHeight: 0,
          flexShrink: 0,
        }}
      >
        {/* Left 60% */}
        <Box sx={{ ...bd, flex: "0 0 60%", minWidth: 0, minHeight: 0 }}>
          <Box
            id="abc"
            sx={{
              height: "100%",
              minHeight: 0,
              display: "grid",
              gridTemplateRows: `
                auto
                auto
                auto
                auto
                minmax(60px, 1fr)
                minmax(60px, 1fr)
                minmax(60px, 1fr)
                auto
                330px
              `,
            }}
          >
            {/* leftBOX 1 */}
            <Box
              sx={{ display: "flex", pt: 1, px: 1, alignItems: "flex-start" }}
            >
              <Box sx={{ flexShrink: 0 }}>
                <Typography variant="h6">Customer : </Typography>
              </Box>
              <Box sx={{ flex: 1, ml: 1, minWidth: 0 }}>
                <Typography sx={{ ...blnk, ...mid }}>
                  {j?.customer_id === 1
                    ? j?.unreg_customer || "Unregistered"
                    : j?.customer_name || j?.cus_name_short || "\u00A0"}
                </Typography>
              </Box>
            </Box>

            {/* leftBOX 2 */}
            <Box sx={{ display: "flex", px: 1, alignItems: "flex-start" }}>
              <Box sx={{ flexShrink: 0 }}>
                <Typography variant="h6">JobName : </Typography>
              </Box>
              <Box sx={{ flex: 1, ml: 1, minWidth: 0 }}>
                <Typography sx={blnk}>
                  {[j?.file_name, j?.doc_name, j?.job_name]
                    .filter(Boolean)
                    .join(" - ") || "\u00A0"}
                </Typography>
              </Box>
            </Box>

            {/* leftBOX 3 */}
            <Box sx={{ display: "flex", px: 1, alignItems: "flex-start" }}>
              <Box sx={{ flexShrink: 0 }}>
                <Typography variant="h6">PO No : </Typography>
              </Box>
              <Box sx={{ flex: 1, px: 1, minWidth: 0 }}>
                <Typography sx={{ ...blnk }}>
                  {j?.po?.code || "\u00A0"}
                </Typography>
              </Box>
              <Box sx={{ flexShrink: 0 }}>
                <Typography variant="h6">PO Date : </Typography>
              </Box>
              <Box sx={{ flex: 0.3, pl: 1, minWidth: 0 }}>
                <Typography sx={blnk}>{j?.po?.when || "\u00A0"}</Typography>
              </Box>
            </Box>

            {/* leftBOX 4 */}
            <Box sx={{ display: "flex", px: 1, alignItems: "flex-start" }}>
              <Box sx={{ flexShrink: 0 }}>
                <Typography variant="h6">Size : </Typography>
              </Box>
              <Box sx={{ flex: 1, pl: 1, minWidth: 0, pb: 1 }}>
                <Typography sx={blnk}>
                  {inf?.size?.length
                    ? inf.size.map((jj, i) => (
                        <span key={i}>
                          <b>{jj.ty}</b>
                          {jj.dt && " - " + jj.dt}
                          {i < inf.size.length - 1 && " | "}
                        </span>
                      ))
                    : "\u00A0"}
                </Typography>
              </Box>
            </Box>

            {/* leftBOX 5 */}
            <Box
              sx={{
                display: "flex",
                borderTop: "1px solid black",
                minHeight: 0,
              }}
            >
              <Box sx={{ p: 1, flexShrink: 0 }}>
                <Typography variant="h6">Materials : </Typography>
              </Box>
              <Box
                sx={{
                  flex: 1,
                  pt: 1.5,
                  pr: 1,
                  minWidth: 0,
                  minHeight: 0,
                  overflow: "auto",
                }}
              >
                <List sx={{ p: 0 }}>
                  <Typography sx={{ color: "darkblue", ...noblnk }}>
                    {inf?.mate?.length
                      ? inf.mate.map((jj, i) => (
                          <span key={i}>
                            <b>{jj.item}</b>
                            {jj.dt && jj.item && " - "}
                            {jj.dt}
                            {i < inf.mate.length - 1 && " | "}
                          </span>
                        ))
                      : "\u00A0"}
                  </Typography>
                </List>
              </Box>
            </Box>

            {/* leftBOX 6 */}
            <Box sx={{ ...bdt, display: "flex", minHeight: 0 }}>
              <Box sx={{ p: 1, flexShrink: 0 }}>
                <Typography variant="h6">Machine : </Typography>
              </Box>
              <Box
                sx={{
                  pt: 1.5,
                  flex: 1,
                  minWidth: 0,
                  minHeight: 0,
                  overflow: "auto",
                }}
              >
                <Typography sx={{ color: "darkblue", ...noblnk }}>
                  {inf?.machine?.length
                    ? inf.machine.map((jj, i) => (
                        <span key={i}>
                          <b>{jj.ty}</b>
                          {jj.dt && " - " + jj.dt}
                          {i < inf.machine.length - 1 && " | "}
                        </span>
                      ))
                    : "\u00A0"}
                </Typography>
              </Box>
            </Box>

            {/* leftBOX 7 */}
            <Box sx={{ ...bdt, display: "flex", minHeight: 0 }}>
              <Box sx={{ p: 1, flexShrink: 0 }}>
                <Typography variant="h6">Finishing : </Typography>
              </Box>
              <Box
                sx={{
                  pt: 1.5,
                  flex: 1,
                  minWidth: 0,
                  minHeight: 0,
                  overflow: "auto",
                }}
              >
                <Typography sx={{ color: "darkblue", ...noblnk }}>
                  {inf?.finishing?.length
                    ? inf.finishing.map((jj, i) => (
                        <span key={i}>
                          <b>{jj.ty}</b>
                          {jj.dt && " - " + jj.dt}
                          {i < inf.finishing.length - 1 && " | "}
                        </span>
                      ))
                    : "\u00A0"}
                </Typography>
              </Box>
            </Box>

            {/* leftBOX 9 */}
            <Box
              sx={{
                display: "flex",
                px: 1,
                pt: 1,
                ...bdt,
                alignItems: "center",
              }}
            >
              <Typography variant="h6">Stock Log : </Typography>
            </Box>

            {/* leftBOX 10 (fixed height) */}
            <Box
              sx={{
                display: "flex",
                px: 1,
                minHeight: 0,
                overflow: "hidden",
              }}
            >
              <List dense sx={{ width: "100%", p: 0 }}>
                {[
                  ...(jobStkRecs || []).slice(0, 10),
                  ...Array(Math.max(0, 10 - (jobStkRecs?.length || 0))).fill(
                    null,
                  ),
                ].map((r, i) => (
                  <ListItemText
                    key={i}
                    sx={{
                      borderBottom: "1px solid #7a7a7a",
                      minHeight: 28,
                      display: "flex",
                      alignItems: "center",
                      textDecoration: r?.state === 2 ? "line-through" : "none",
                      color: "darkblue",
                      fontStyle: "italic",
                    }}
                    primary={
                      r
                        ? `${r?.rb_data?.item ? r?.rb_data?.item + " - " : ""}${
                            whatList(r?.rb_data?.mate_type)?.find(
                              (p) => p.id === r?.rb_data?.mate_id,
                            )?.display_as || "-"
                          } ${r?.rb_type === "job_mate_use" ? "-" : "+"}${Number(
                            r?.rb_data?.change || 0,
                          ).toLocaleString()} ${
                            r?.rb_data?.mate_type === "Paper"
                              ? "Sheets"
                              : "Loops"
                          }`
                        : "\u00A0"
                    }
                  />
                ))}
              </List>
            </Box>
          </Box>
        </Box>

        {/* Right 40% */}
        <Box sx={{ ...bd, flex: "0 0 40%", minWidth: 0, minHeight: 0 }}>
          <Box
            id="abc"
            sx={{
              height: "100%",
              minHeight: 0,
              display: "grid",
              gridTemplateRows: `
                auto
                auto
                auto
                auto
                minmax(60px, 1fr)
                minmax(60px, 1fr)
                minmax(60px, 1.5fr)
                auto
                330px
              `,
            }}
          >
            {/* rightBOX 1 */}
            <Box
              sx={{ display: "flex", px: 1, pt: 1, alignItems: "flex-start" }}
            >
              <Box sx={{ flexShrink: 0 }}>
                <Typography variant="h6">Started : </Typography>
              </Box>
              <Box sx={{ flex: 1, px: 1, minWidth: 0 }}>
                <Typography sx={{ ...blnk }}>
                  {inf?.start_at || "\u00A0"}
                </Typography>
              </Box>
              <Box sx={{ flexShrink: 0 }}>
                <Typography variant="h6">Deadline : </Typography>
              </Box>
              <Box sx={{ flex: 1, pl: 1, minWidth: 0 }}>
                <Typography sx={blnk}>
                  {j?.delivery?.deadline || "\u00A0"}
                </Typography>
              </Box>
            </Box>
            {/* rightBOX 3 */}
            <Box
              sx={{ display: "flex", px: 1, pt: 1, alignItems: "flex-start" }}
            >
              <Box sx={{ flexShrink: 0 }}>
                <Typography variant="h6">Artwork : </Typography>
              </Box>
              <Box sx={{ flex: 1, px: 1, minWidth: 0 }}>
                <Typography sx={{ ...blnk }}>
                  {(j?.artwork?.status === 1 && j?.artwork?.ok_when) ||
                    "\u00A0"}
                </Typography>
              </Box>
              <Box sx={{ flexShrink: 0 }}>
                <Typography variant="h6">Proof : </Typography>
              </Box>
              <Box sx={{ flex: 1, pl: 1, minWidth: 0 }}>
                <Typography sx={blnk}>
                  {(j?.proof?.status === 1 && j?.proof?.ok_when) || "\u00A0"}
                </Typography>
              </Box>
            </Box>
            {/* rightBOX 2 */}
            <Box
              sx={{ display: "flex", px: 1, pt: 1, alignItems: "flex-start" }}
            >
              <Box sx={{ flexShrink: 0 }}>
                <Typography variant="h6">Ended : </Typography>
              </Box>
              <Box sx={{ flex: 1, px: 1, minWidth: 0 }}>
                <Typography sx={{ ...blnk }}>
                  {inf?.finish_at || "\u00A0"}
                </Typography>
              </Box>
              <Box sx={{ flexShrink: 0 }}>
                <Typography variant="h6">LastDeli : </Typography>
              </Box>
              <Box sx={{ flex: 1, pl: 1, minWidth: 0 }}>
                <Typography sx={blnk}>
                  {j?.job_status === 4
                    ? j?.delivery?.log
                        ?.map((d) => d.deli_date)
                        .sort()
                        .at(-1) || "\u00A0"
                    : "\u00A0"}
                </Typography>
              </Box>
            </Box>
            {/* right BOX 3 */}
            <Box sx={{ display: "flex", px: 1, alignItems: "flex-start" }}>
              <Box sx={{ flexShrink: 0 }}>
                <Typography variant="h6">Bill : </Typography>
              </Box>
              <Box sx={{ flex: 1, pl: 1, minWidth: 0, pb: 1 }}>
                <Typography sx={blnk}>
                  {(inf?.unit_price &&
                    inf.unit_count &&
                    `${inf.unit_price.toLocaleString("en-LK", { style: "currency", currency: "LKR" })}
                    ${!inf?.noVat ? "+VAT x " : " x "}${inf.unit_count.toLocaleString()}`) ||
                    "\u00A0"}
                </Typography>
              </Box>
            </Box>
            {/* rightBOX 3 */}
            <Box sx={{ ...bdt, display: "flex", minHeight: 0 }}>
              <Box sx={{ p: 1, flexShrink: 0 }}>
                <Typography variant="h6">Contact : </Typography>
              </Box>
              <Box
                sx={{
                  pt: 1.5,
                  flex: 1,
                  minWidth: 0,
                  minHeight: 0,
                  overflow: "auto",
                }}
              >
                <Typography sx={{ color: "darkblue", ...noblnk }}>
                  {inf?.contact?.length
                    ? inf.contact.map((jj, i) => (
                        <span key={i}>
                          <b>{jj.ty}</b>
                          {jj.dt && " - " + jj.dt}
                          {i < inf.contact.length - 1 && " | "}
                        </span>
                      ))
                    : "\u00A0"}
                </Typography>
              </Box>
            </Box>
            {/* rightBOX 4 */}
            <Box
              sx={{
                display: "flex",
                borderTop: "1px solid black",
                minHeight: 0,
              }}
            >
              <Box sx={{ p: 1, flexShrink: 0 }}>
                <Typography variant="h6">DeliverTo : </Typography>
              </Box>
              <Box
                sx={{
                  flex: 1,
                  pt: 1.5,
                  pr: 1,
                  minWidth: 0,
                  minHeight: 0,
                  overflow: "auto",
                }}
              >
                <Typography sx={{ color: "darkblue", ...noblnk }}>
                  {j?.delivery?.address || "\u00A0"}
                </Typography>
              </Box>
            </Box>

            {/* leftBOX 8 */}
            <Box sx={{ ...bdt, display: "flex", minHeight: 0 }}>
              <Box sx={{ p: 1, flexShrink: 0 }}>
                <Typography variant="h6">Others : </Typography>
              </Box>
              <Box
                sx={{
                  pt: 1.5,
                  flex: 1,
                  minWidth: 0,
                  minHeight: 0,
                  overflow: "auto",
                }}
              >
                <Typography sx={{ color: "darkblue", ...noblnk }}>
                  {inf?.others?.length
                    ? inf.others.map((jj, i) => (
                        <span key={i}>
                          <b>{jj.ty}</b>
                          {jj.dt && " - " + jj.dt}
                          {i < inf.others.length - 1 && " | "}
                        </span>
                      ))
                    : "\u00A0"}
                </Typography>
              </Box>
            </Box>
            {/* leftBOX 9 */}
            <Box
              sx={{
                display: "flex",
                px: 1,
                pt: 1,
                ...bdt,
                alignItems: "center",
              }}
            >
              <Typography variant="h6">Notes : </Typography>
            </Box>
            {/* leftBOX 10 (fixed height) */}
            <Box
              sx={{
                display: "flex",
                px: 1,
                minHeight: 0,
                overflow: "hidden",
              }}
            >
              <List dense sx={{ width: "100%", p: 0 }}>
                {[
                  ...(inf?.notes || []).slice(0, 10),
                  ...Array(Math.max(0, 10 - (inf?.notes?.length || 0))).fill(
                    null,
                  ),
                ].map((r, i) => (
                  <ListItemText
                    key={i}
                    sx={{
                      borderBottom: "1px solid #7a7a7a",
                      minHeight: 28,
                      display: "flex",
                      alignItems: "center",
                      textDecoration: r?.state === 2 ? "line-through" : "none",
                      color: "darkblue",
                      fontStyle: "italic",
                    }}
                    primary={r?.note || "\u00A0"}
                  />
                ))}
              </List>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Bottom (stays same) */}
      <Box
        sx={{
          ...bd,
          flex: 1,
          mx: 3,
          mb: 3,
          minHeight: 0,
          backgroundSize: "4mm 4mm",
          backgroundImage:
            "linear-gradient(to right, #c0d4ff 1px, transparent 1px), linear-gradient(to bottom, #c0d4ff 1px, transparent 1px)",
        }}
      />
    </Box>
  );
}
